import React, { Component, Fragment } from "react";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import NewSedeForm from "./NewSedeForm";

class NewSedeModal extends Component {
  state = {
    modal: false
  };

  toggle = () => {
    this.setState(previous => ({
      modal: !previous.modal
    }));
  };

  render() {
    const create = this.props.create;

    var title = "Editando Value Stream";
    var button = <Button onClick={this.toggle}>
      Editar
      </Button>;
    if (create) {
      title = "Creando Nuevo Value Stream";

      button = (
        <Button
          color="primary"
          className="float-end"
          onClick={this.toggle}
          style={{ minWidth: "200px" }}
        >
          Crear Nuevo
        </Button>
      );
    }

    return (
      <Fragment>
        {button}
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>{title}</ModalHeader>

          <ModalBody>
            <NewSedeForm
              resetState={this.props.resetState}
              toggle={this.toggle}
              sede={this.props.sede}
            />
          </ModalBody>
        </Modal>
      </Fragment>
    );
  }
}

export default NewSedeModal;